import { getDisplayValue } from "../../formatting/string-manipulation";
import type { SatelliteImage } from "../../types";
import type { Field } from "../tabs/types";

const emptySatelliteImage: SatelliteImage = { mediaLink: "", caption: "" };

export function buildSatelliteImageryFields(
  satelliteImagery?: Array<SatelliteImage>,
  startIndex = 0,
): Array<Field> {
  const images = satelliteImagery?.length
    ? satelliteImagery
    : [emptySatelliteImage];

  return images.flatMap(({ mediaLink, caption }, imageIndex): Array<Field> => {
    const fieldIndex = startIndex + imageIndex * 2;

    return [
      {
        name: `Media Link ${imageIndex + 1}`,
        type: "text",
        index: fieldIndex,
        value: getDisplayValue(mediaLink),
      },
      {
        name: `Caption ${imageIndex + 1}`,
        type: "text",
        index: fieldIndex + 1,
        value: getDisplayValue(caption),
      },
    ];
  });
}
